import Model from "./Model";
import {Expose, Type} from "class-transformer";

export default class SearchResult extends Model {
    type: string;
    distance: number;

    @Expose({name: "model_id"})
    modelId: number;

    @Expose({name: "image_url"})
    imageUrl: string;

    @Expose({name: "primary_text"})
    primaryText: string;

    @Expose({name: "entity_properties"})
    entityProperties: object;

    distanceInMiles(): number{
        return Math.round(this.distance * 0.621371 * 100) / 100;
    }
}


// WEBPACK FOOTER //
// ./app/client/_data/models/SearchResult.ts